<template>
  <footer class="site-footer">
    <div class="footer-inner">
      <!-- 公司名稱 -->
      <div class="footer-company">提供高效、专业、稳定的广告投放服务</div>

      <!-- 導航連結 -->
      <!-- <div class="footer-links">
        <a href="#about">關於我們</a>
        <span class="sep">|</span>
        <a href="#contact">聯絡我們</a>
        <span class="sep">|</span>
        <a href="#join">加入我們</a>
      </div> -->

      <!-- <div class="footer-divider"></div> -->

      <div class="footer-bottom">
        <!-- 聯繫資訊 -->
        <div class="footer-contact">
          <div class="contact-item">
            <span class="icon">
              <img src="@/assets/phoneIcon1.svg" alt="" />
            </span>
            <div class="right">
              <div class="title">电话:</div>
              <div class="value">18559216736</div>
            </div>
          </div>
          <div class="contact-item">
            <span class="icon"><img src="@/assets/emailIcon.svg" alt="" /></span>
            <div class="right">
              <div class="title">邮箱:</div>
              <div class="value">linxiang2098@gmail.com</div>
            </div>
          </div>
          <!-- <div class="contact-item">
            <span class="icon"><img src="@/assets/addressIcon.svg" alt="" /></span>
            <span>地址：Room1503-09, 15/F,Causeway Bay Centre,15-23Sugar Street,Causeway Bay,Hong Kong</span>
          </div> -->
        </div>
      </div>
      <!-- ✅ 备案号 -->
      <div class="footer-record">
        <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">
          <img class="record-icon" src="@/assets/beian.png" alt="备案" />
          闽ICP备2026001522
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'SiteFooter'
}
</script>

<style scoped>
.site-footer {
  margin-top: 24px;
  padding: 50px 0;
  background: linear-gradient(180deg, #f4f7ff 0%, #f8fbff 100%);
  font-size: 12px;
  color: #4b5563;
}

.footer-inner {
  max-width: 1120px;
  margin: 0 auto;
  padding: 0 16px;
}

/* 公司名稱 */
.footer-company {
  text-align: center;
  font-size: 26px;
  font-weight: 600;
  background: linear-gradient(90deg, #1a41e7 0%, #10b4f4 100%);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* 上方導航 */
.footer-links {
  margin-top: 15px;
  text-align: center;
  font-size: 14px;
  color: #2a4ae2;
}

.footer-links a {
  color: #2a4ae2;
  cursor: pointer;
  text-decoration: none;
}

.footer-links a:hover {
  text-decoration: underline;
}

.footer-links .sep {
  margin: 0 40px;
  color: #000;
}

/* 分割線 */
.footer-divider {
  margin: 16px 0 30px;
  border-bottom: 1px solid #d9e0ff;
}

/* 底部主體：左聯繫右二維碼 */
.footer-bottom {
  display: flex;
  justify-content: flex-start;
  gap: 24px;
}

/* 聯繫資訊 */
.footer-contact {
  display: flex;
  gap: 15px;
  margin-top: 50px;
}

.contact-item {
  width: 480px;
  background: #fff;
  border-radius: 20px;
  padding: 40px;
  display: flex;
  align-items: flex-start;
  margin-bottom: 6px;
  display: flex;
}
.contact-item .title {
  font-size: 18px;
  font-weight: bold;
  color: #0d0d0e;
  margin-bottom: 5px;
}
.contact-item .value {
  font-size: 18px;
  font-weight: bold;
  color: #0d0d0e;
}

.contact-item .icon {
  display: inline-flex;
  width: 18px;
  justify-content: center;
  margin-right: 10px;
  color: #9ca3af;
  margin-top: 5px;
}

/* 二維碼區域 */
.footer-qrcodes {
  /* flex: 1; */
  display: flex;
  justify-content: flex-end;
  gap: 16px;
}

.qrcode-item {
  text-align: center;
}

.qrcode-placeholder {
  width: 64px;
  height: 64px;
  border-radius: 10px;
  background: #e5e7eb;
}

/* 如果用圖片就這樣：
.qrcode-item img {
  width: 64px;
  height: 64px;
  border-radius: 10px;
}
*/

.qrcode-text {
  margin-top: 4px;
  font-size: 11px;
  color: #6b7280;
}

/* 备案号 */
.footer-record {
  margin-top: 24px;
  text-align: center;
  font-size: 12px;
  color: #9ca3af;
  
}

.footer-record a {
  color: #9ca3af;
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 14px;
}

.footer-record a:hover {
  color: #6b7280;
  text-decoration: underline;
}

.record-icon {
  width: 14px;
  height: 14px;
  opacity: 0.8;
  margin-right: 5px;
}
.footer-record {
  font-size: 11px;
}
/* ---------- 響應式 ---------- */

@media (max-width: 768px) {
  .site-footer {
    padding: 24px 0 20px;
  }

  .footer-bottom {
    flex-direction: column;
    align-items: flex-start;
  }

  .footer-qrcodes {
    justify-content: flex-start;
  }
}

@media (max-width: 480px) {
  .footer-inner {
    padding: 0 12px;
  }
  .footer-company {
    font-size: 13px;
  }
  .footer-links {
    font-size: 11px;
  }
  .footer-bottom {
    gap: 16px;
  }
}
</style>
